import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, TemplateRef, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {InventoryService} from './inventory.service';
import {HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import {AppService} from '@irb/app.service';
import {SelectAllGridParent} from '@irb-common/components/irebal-ag-grid-ent-avatar/irb-select-all-grid-parent';
import {IrbAgGridExportService} from '@irb-common/components/irebal-ag-grid-ent-avatar/irb-ag-grid-export/irb-ag-grid-export.service';
import {MenuItemDef} from 'ag-grid-enterprise';
import {InventoryGridLayoutService} from './inventory.grid-layout.service';
import {
    IExportRequest,
    IOrders,
    IOrdersSupportDetails,
    IThresholdConfigSettings,
    IUpdateAmtType,
    IUpdateContactNumbers,
    IValidateThinkPipeExport,
    IWorkflowDialogData,
    IMasterAccountAccess
} from '@irb/irb-orders/irb-orders.model';
import {OrderStatusAction} from './order-status-action'
import {IEvent, IEventSubscriber, IrbAppEvents, IrbClientsEvents, IrbRebalanceEvents, IrbSettingsEvents} from '@irb/irb-common/events';
import {ExportInfoService} from './export-info.service';
import {MatDialog, MatDialogConfig, MatDialogRef} from '@angular/material/dialog';
import {IAlertDialogData, IApplyFilterOnLanding, IFilterModel, IUserDetails} from '@irb/app.model';
import {IrbOrdersEvents} from '@irb/irb-orders/IrbOrdersEvents';
import {takeUntil} from "rxjs/operators";
import {ReplaySubject, Subscription} from "rxjs";
import {DatePipe} from '@angular/common';
import {FilterChipsComponent} from "@irb-common/components/filter-chips/filter-chips.component";
import {FiltersForGridComponent} from '@irb-common/components/filters-for-grid/filters-for-grid.component';
import {IrbOrdersService} from "@irb/irb-orders/irb-orders.service";
import {IMasterAccountAccessResponse} from '@irb/irb-orders/irb-orders.model';
import { interval } from "rxjs";
import { IGlobalSettings } from '@irb/irb-settings/irb-settings.model';
import { UtilityService } from '@irb/irb-common/services/utility.service';
import { ContextType, CurrentContextService, IContext } from '@charlesschwab/as-ui-core';
import { CalltoactionService } from '@irb/irb-common/components/calltoaction/calltoaction.service';

@Component({ standalone: false,
    selector: 'irb-orders-inventory',
    templateUrl: './inventory.component.html',
    styleUrls: ['./inventory.scss'],
    providers:[DatePipe],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class InventoryComponent implements OnInit, OnDestroy, IEventSubscriber, SelectAllGridParent {
    filterDisplayNamesData: { key: string, mapData: { displayName: string, customData:any } }[];
    @Input() current: string;
    @Input() ordersLabel: string;
    @Input() globalSettings: IGlobalSettings;
    @Output()
    callback = new EventEmitter<any>();

    totalRecordsFromServer: number;
    isSelectedAll: boolean;
    uniqueField: string = 'orderID';
    deselectedFromSelectAllRecords: any[] = [];
    headerCheckBoxState: string;
    disableActionBtn: boolean = true;
    diableBlockAllocations: boolean = true;
    diableAllocations: boolean = false;
    ignoreUserDeselectedRecords: boolean = false;
    blockDeskContact:string = '800-766-9922'; //TODO: integrate phone number api
    isOptionTradeEnabled: boolean;//TODO: isOptionTradeEnabled() end point pending integration

    ordersSupportDetails: IOrdersSupportDetails;
    params: any;
    public rowData: any[];
    public info: string;
    orders:any;
    gridOptions: any;
    blockOrderGridOptions: any;
    defaultColDef: any;
    columnDefs: any;
    rowSelection: any;
    rowModelType: any;
    currentDisplayed: number;
    _portfolios: any[];
    sideBar: any;
    frameworkComponents: any;
    footerContent: any;
    _isSelectedAll: boolean;
    _filterCriteria: string;
    _deselectedFromSelectAllRecords: any[] = [];

    _totalRecords: number;
    _blockOrderFilterActive = false;
    _recordsLoadedInGrid:any = 0;
    @ViewChild("validateDialogTemplate")
    validateDialogTemplate: TemplateRef<any>;

    @ViewChild("exportBlockAllocation")
    public exportBlockAllocation: TemplateRef<any>;
    
    @ViewChild("viewBlockOrders")
    public blockOrdersTemplate: TemplateRef<any>;

    _thresholdConfigSettings: IThresholdConfigSettings;

    @ViewChild("workflowDialogTemplate")
    workflowDialogTemplate: TemplateRef<any>;
    workflowDialogData:IWorkflowDialogData;

    openGrid:boolean;
    viewBlockOrder:any;
    blockOrder:IOrders;
    actionType:string;
    exportRequest: IExportRequest;
    validateThinkPipeFormat:IValidateThinkPipeExport;
    overlayType:any;

    @ViewChild("irbProgressBarOrdStatUpdId")
    irbProgressBarOrdStatUpdId: TemplateRef<any>;
    ordStatUpdIdprogressBarValue:number = -1;

    @ViewChild("orderHistoryTemplate")
    orderHistoryTemplate: TemplateRef<any>;

    algorithmPermissionsList:any;
    applyFilterOnLanding: IApplyFilterOnLanding;

    currentOrderData:any;
    inventoryComponentRef:InventoryComponent;

    eventSubscription: Subscription;
    private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);
    envLastUsedContactNo: any;

    disableOrderActionBtn:boolean = true;
    disableEditTradeInstBtn:boolean = true;
    disableMarkAsCancelled: boolean = true;
    routeQueryParams$: Subscription;
    loadingOverlayComponentParams: any;
    orderHistoryDialogRef: MatDialogRef<any>;
    selectedOrDeSelectedRecords: any[] = [];
    _filterChipModel: any = {};
    private showClearFilters: boolean = false;
    @ViewChild("filterChipsComp")
    filterChipsComp: FilterChipsComponent;

    @ViewChild("gridPresetFiltersComp") gridPresetFiltersComp: FiltersForGridComponent;
    //listOfPresetFilters: any;
    appliedFromPresetFilter: boolean = false;
    applyDefaultFilter: boolean = true;
    isUiTest = false;
    filterForGrid = 'orderblotteractive';
    @ViewChild("inventoryGrid") inventoryGrid: any;
    private showThresholdAlert = true;
    updateMultipleOrdersSub: Subscription;    
    hasServerSideDatasource: boolean = false;
    totalSelectedOrderCount:any = 0;
    ENABLE_FLYOUT: boolean = true;
    @ViewChild('accountNumberOverlay') accountNumberOverlay: TemplateRef<any>;
    row: any;
    sacMenuItems = [
        { sanc: 'A_BAL', label: 'Balances' },
        { sanc: 'A_POS', label: 'Positions' },
        { sanc: 'A_TRAN', label: 'Transactions' },
        { sanc: 'A_COST', label: 'Cost Basis' },
        { sanc: 'T_ORD', label: 'Order Entry' }
    ];
    userDetails: IUserDetails;
    redirectURL: string;

    constructor(
        public readonly pfs: InventoryService,
        private readonly gls: InventoryGridLayoutService,
        public as: AppService,
        public readonly router: Router,
        public ges: IrbAgGridExportService,
        public orderStatusAction:OrderStatusAction,
        public exportService:ExportInfoService,
        public dialog: MatDialog,
        private datePipe: DatePipe,
        private route: ActivatedRoute,
        private ors: IrbOrdersService,
        private util: UtilityService,
        private cxs: CurrentContextService,
        private ctas: CalltoactionService
    ) {
        this.userDetails = this.as.getItem("IRB_APP_CONFIG") as IUserDetails;
        this.ENABLE_FLYOUT = this.userDetails?.featureFlags?.ENABLE_FLYOUT;
        this.redirectURL = this.userDetails?.veoRedirectUrl;
        this._thresholdConfigSettings = {} as IThresholdConfigSettings;
        this.getOrderTresholdLimits();
        this.getIsOptionTradeEnabled();
        this.getPermissions();
        this.getContactNumbers();
        this.setFilterChipsDisplayNames();
        this.routeQueryParams$ = route.queryParams.subscribe(params => {
              if (params['rebalanceId'] && params['portfolio']) {
                  this.showPortfolioResultDetail( params['rebalanceId'], params['portfolio']);
              }
          }
        );
    }

    ngOnInit() {
        if (this.current === 'resolvedOrders') {
            this.filterForGrid = 'orderblotterclosed';
        }

        this.loadingOverlayComponentParams = {parentObject: this};
        this.applyFilterOnLanding = this.as.getWindowsState() || {} as IApplyFilterOnLanding;
        //this.applyDefaultFilter = false;// temporary remove when uncomment irb-filters-for-grid in template
        if (this.applyFilterOnLanding.isUpdatRequired) {
            this.applyDefaultFilter = false;
        }
        this.gls.init(this.current);
        this.pfs.isArchivedOrders = false;

        let rowIdIteration = -1;
        this.gridOptions = {
            context: {componentParent: this, parentId: 'order-blotter-inventory-' + this.current},
            rowHeight:32,
            rowModelType: 'serverSide',
            columnDefs: this.gls.getColumnDefs(this),
            rowSelection: 'multiple',
            rowClassRules:{ 'modifiedRow': (params: any) => {
                    if (params.data) {
                        return params.data.edited;
                    }
                },
                'spreadOptionOrder': (params: any) => {
                    if (params.data && ((params.data.isRollTrade) //||
                        //params.data.isSwapExchange ||
                        //params.data.securityType === "Option"
                        ) ) {
                        return true;
                    }
                },
            },
            onSortChanged: () => {
                if(this.hasServerSideDatasource) {
                    this.setDatasource();
                } else {
                    this.params.api.setGridOption('serverSideDatasource', this.setDatasource());
                }
            },
            onFilterChanged: () => {
                this.filterChanged();
            },
            getRowId: (params: any) => {
                rowIdIteration++;
                const rowId = 'RowId' + rowIdIteration;
                return params.data.orderID + rowId;
            },
            processCellForClipboard: this.processCellForClipboard.bind(this)
        };
        this.rowModelType = 'serverSide';
        this.getOrdersSupportDetails();
        this.frameworkComponents = this.gls.getFrameworkComponents();
        this.sideBar = {
            toolPanels: [{
                id: 'filters',
                labelDefault: 'FILTERS',
                labelKey: 'filters',
                iconKey: 'filter',
                toolPanel: 'agFiltersToolPanel',
                toolPanelParams: {
                    suppressExpandAll: true,
                    suppressFilterSearch: true,
                    suppressSyncLayoutWithGrid: true,
                },
            }],
            defaultToolPanel: 'filters'
        };

        this.eventSubscription = this.as.getEvents().pipe(takeUntil(this.destroyed$)).subscribe((s) => { this.processEvent(s); });
    }

    processCellForClipboard(params: any): any {
        const colDef: any = params.column.getColDef();

        if(colDef.field === "orderStatus" && params.value === "SUBMITTED_TO_VEO") {
            return "SUBMITTED";
        }

        return this.inventoryGrid.processCellForClipboard(params);
    }

    processEvent(event: IEvent) {
        switch (event.type) {
            case IrbAppEvents.GRID_REFRESH:
                this.refreshGrid();
                break;
            case IrbAppEvents.GRID_FILTER_RESET:
                this.clearAllFiltersAndSelections();
                break;
            case IrbRebalanceEvents.NAVIGATE_FROM_PORTFOLIO_RESULT_DETAIL:
                this.filterDetailsByRebalIdandPortfolio(event);
                break;
        }
    }

    ngOnDestroy() {
        this.destroyed$.next(true);
        this.destroyed$.complete();
    }

    onGridReady(params: any) {
        this.params = params;
        if(!this.applyFilterOnLanding.isUpdatRequired){
            if (this.current === 'resolvedOrders') {
                this.applyTodayFilter();
                this.params.api.setGridOption('serverSideDatasource', this.setDatasource());
            } else if (this.current === 'automatedOrders') {
                this.params.api.setGridOption('serverSideDatasource', this.setDatasource());
            } else {
                if (!this.applyDefaultFilter) {
                    this.params.api.setGridOption('serverSideDatasource', this.setDatasource())
                } else {
                    if (this.gridPresetFiltersComp && this.gridPresetFiltersComp.onFilterChange) {
                        this.gridPresetFiltersComp.onFilterChange();
                    }

                    if(this.hasServerSideDatasource) {
                        this.setDatasource();
                    } else {
                        this.params.api.setGridOption('serverSideDatasource', this.setDatasource());
                    }
                }
            }
        }

        this.gls.initFilters().then(() => this.applyLandingFilters());
        this.params.api.addEventListener('cellClicked', this.rowClickedAction.bind(this));
    }

    setDatasource() {
        this.hasServerSideDatasource = true;
        const self = this;
        return {
            getRows: (params: any) => {
                this.ors.getMasterAccountsAccess().subscribe((res: IMasterAccountAccessResponse) => {
                    if(!res?.responseData?.isMasterAccountsAccessChanged || (res?.responseData?.isMasterAccountsAccessChanged && res?.responseData?.lostMaster?.length > 0)) {
                        this.overlayType = 'loading';
                        this.callback.next({name: 'spinner', value: true});
                        self.params.api.showLoadingOverlay();
                        this._filterChipModel = params.request.filterModel;
                        this.appliedFromPresetFilter = false;
                        
                        this.pfs.getOrders(params, this.current).subscribe(data => {
                            this.completeGetOrders(data, params);
                        },()=>{
                            this.params.api.hideOverlay();
                            this.callback.next({name: 'spinner', value: false});
                        },()=>{
                            this.callback.next({name: 'spinner', value: false});
                        });
                    } else {
                        this.as.fireEvent(IrbAppEvents.SHOW_ALERT,{
                            dTitle: "Blotter Access Restricted",
                            dType: 'WARN',
                            msg: "Access to the blotter has been restricted. This is likely caused by a change in your user access. Please consult with your firm's security administrator for information regarding changes to your access.",
                            onCancel: () => this.router.navigateByUrl('/'),
                            onProceed: () => this.router.navigateByUrl('/')
                        } as IAlertDialogData);
                    }
                });
            }
        };
    }

    completeGetOrders(data: any, params: any) {
        const self = this;
        this._filterCriteria = this.pfs._filterCriteria;

        if (this.gridPresetFiltersComp) {
            this.gridPresetFiltersComp.handleGridFilterChanges(this._filterCriteria);
        }

        this.orders = <IOrders[]>data.body;
        const ex: any = (this.orders as any).responseUtilityMap;

        if (ex) {
            if (ex['Controller Exception']) {
                const err: any = {};
                err.message = 'order blotter inv call failed. ';
                err.message += ex['Controller Exception'];
                this.params.api.hideOverlay();
                this.callback.next({name: 'spinner', value: false});
                throw new Error(err.message);
            }
        }

        this.getCurrentCount(data.headers);

        if (this.currentDisplayed ===  0) {
            this.showClearFilters = this._filterCriteria  !== '';
            this.params.api.showNoRowsOverlay();
        } else {
            this.params.api.hideOverlay();
        }

        params.success({ rowData: this.orders });

        if (this.pfs.isArchivedOrders !== this.pfs.isArchivedOrdersPrevious) {
            this.getOrdersSupportDetails();
            this.pfs.isArchivedOrdersPrevious = this.pfs.isArchivedOrders;
        }
        
        if (self.pfs.openEditMode) {
            self.as.fireEvent(IrbClientsEvents.SHOW_EDIT_TRADING_INSTRUCTIONS, {
                data: {data: self.orders[0]},
                parent: self,
                orderhistoryinit: true
            });
            self.pfs.openEditMode = false;
        }
    }

    refreshGrid() {
        this.selectedOrDeSelectedRecords = [];
        this.deselectedFromSelectAllRecords = [];
        this.ignoreUserDeselectedRecords = false;
        this.getOrdersSupportDetails();
        this.params.api.deselectAll();      
        this.isSelectedAll= false;
        this.headerCheckBoxState = 'unchecked';
        this.enableDisableBtns();
        this.params.api.refreshServerSide({purge:true});
    }

    refreshGridBtnAction() { // keeps row selection
        this.ignoreUserDeselectedRecords = true;
        this.getOrdersSupportDetails();
        this.params.api.refreshServerSide({purge:true});
    }

    quickfilterSetModel(ordersSupportDetails: IOrdersSupportDetails) {
        this.params.api.getColumnFilterInstance("quickfilter").then((f: any) => {
            f.setModel(ordersSupportDetails);
        });
    }

    applyFilter() {
        this.params.api.setGridOption('serverSideDatasource', this.setDatasource())
    }

    applyTodayFilter() {
        const today = this.getCurrentDate();
        this.params.api.setColumnFilterModel('modifiedDate', {
            type: 'inRange',
            filterFrom: today,
            filterTo: today
        });
    }

    applyLandingFilters() {
        let c = 0;

        if(this.applyFilterOnLanding) {            
            this.applyFilterOnLanding.filterModels?.forEach((filterModel: IFilterModel) => {
                if(filterModel.isUpdatRequired && filterModel.name) {
                    filterModel.isUpdatRequired = false;
                    
                    if (this.params.api) {
                        if(filterModel.value?.dateFrom && filterModel.value?.dateTo) {
                            this.params.api.getColumnFilterInstance(filterModel.name).then((f:any) => {
                                f.setModel({
                                    filterFrom: filterModel.value.dateFrom,
                                    filterTo: filterModel.value.dateTo
                                });
                            }); 
                        } else if(filterModel.filter) {
                            this.params.api.getColumnFilterInstance(filterModel.name).then((f:any) => {
                                f.setModel({ type: 'startsWith', filter: filterModel.filter}); 
                            });
                        } else {
                            this.params.api.getColumnFilterInstance(filterModel.name).then((f:any) => {
                                if (filterModel.name === 'masterAccount') {
                                  const m = this.gls.advisorList.length ? this.gls.advisorList : filterModel.value;
                                  f.setFilterValues(m);
                                }
                                f.setModel({ values: filterModel.value });
                            });
                        }
                                           
                        c++;
                    }
                }
            });

            if (this.applyFilterOnLanding.filterModel) {
                let filterModel = this.applyFilterOnLanding.filterModel;

                if(filterModel.isUpdatRequired && filterModel.name && filterModel.value) {
                    filterModel.isUpdatRequired = false;
                    
                    if (this.params.api) {
                        this.params.api.getColumnFilterInstance(filterModel.name).then((f:any) => {
                            f.setModel({
                                values: filterModel.value
                            });
                        });                    
                        c++;
                    }
                }
            }

            if(c > 0) {
                setTimeout(() => { 
                    this.params?.api?.onFilterChanged();
                    this.applyFilterOnLanding.isUpdatRequired = false;
                    this.params?.api?.setGridOption('serverSideDatasource', this.setDatasource()); 
                });
            }
        }
    }

    getOrdersSupportDetails(){
        this.pfs.getOrdersSupportDetails(this.current).subscribe((ordersSupportDetails: IOrdersSupportDetails) => {
            this.ordersSupportDetails = ordersSupportDetails;
            this.quickfilterSetModel(this.ordersSupportDetails);
            this.setCustomFilterLayout();
            this.setFooter();
        });
    }

    getCurrentCount(headers: HttpHeaders) {
        const contentRange = typeof headers?.get === 'function' && headers.get('Filter-Count');
        const lengthOfContentRange = contentRange ? contentRange.trim().length : 0;
        const indexOfSlash = contentRange ? contentRange.toString().indexOf('/') : 0;
        this.currentDisplayed = contentRange ? parseInt(contentRange.toString().substring(indexOfSlash + 1, lengthOfContentRange)) : 0;
        let loadedRange = contentRange ? contentRange.toString().substring(0, indexOfSlash) : '';
        const lengthOfLoadedRange = loadedRange ? loadedRange.trim().length : 0;
        if(lengthOfLoadedRange) {
            let indexOfHyphen = loadedRange ? loadedRange.toString().indexOf('-') : 0;
            if(indexOfHyphen > 0) {
                this._recordsLoadedInGrid = loadedRange ? loadedRange.toString().substring(indexOfHyphen + 1, lengthOfLoadedRange) : 0;
                if(this.currentDisplayed >  0) {
                    this._recordsLoadedInGrid = Number(this._recordsLoadedInGrid) + 1;
                } else {
                    this._recordsLoadedInGrid = 0;
                }
            } else {
                this._recordsLoadedInGrid = 0;
            }
        } else {
            this._recordsLoadedInGrid = 0;
        }

        this.setFooter();
    }

    setFooter() {
        if(this.current === 'activeOrders') {
            this._totalRecords = this.ordersSupportDetails?.activeOrders;
        } else if(this.current === 'resolvedOrders') {
            this._totalRecords = this.ordersSupportDetails?.resolvedOrders;
        } else if(this.current === 'automatedOrders') {
            this._totalRecords = this.ordersSupportDetails?.automatedOrders;
        }


        if (!this._totalRecords) {this._totalRecords = 0;}
        this.footerContent = (this.currentDisplayed? this.currentDisplayed : '0')  + ' of ' + this._totalRecords + ' orders displayed';
        this.totalRecordsFromServer = this.currentDisplayed;
    }

    setFilterByOrderId(orderId: number | string) {
        const state: IApplyFilterOnLanding = {
            tabname: 'Closed',
            isUpdatRequired: true,
            openEditModel: true,
            filterModels: [
                { name: 'veoOrderID', value: String(orderId), isUpdatRequired: true }
            ]
        } as IApplyFilterOnLanding;
        this.router.navigateByUrl('/orders/order-blotter', {state: state});
        if (this.current === 'activeOrders') {
            this.callback.next({name: 'viewParentDetails', value: (this.globalSettings?.isAutoRebalanceEnabled) ? 2 : 1});
        } else {
            this.filterDetailsByRebalIdandPortfolio({data:{state:state}} as IEvent);
        }

    }
    clearAllFilters() { // this method is used in header compoment
        this.ignoreUserDeselectedRecords = false;
        this._filterCriteria = '';
        this.pfs.clearCriteria();
        this.params.api.setFilterModel(null);
        this.quickfilterSetModel(this.ordersSupportDetails);
        this.setCustomFilterLayout();
        this.pfs.isArchivedOrders = false;
    }
    clearAllFiltersAndSelections(){
        this.ignoreUserDeselectedRecords = false;
        this.params.api.deselectAll();
        this.clearAllFilters();
        this.isSelectedAll= false;
        this.headerCheckBoxState = 'unchecked';
        this.enableDisableBtns();     
    }
    isDeselectedRecordsPresent(rowData:any){
        let isRecordPresent:boolean = true;
        this.deselectedFromSelectAllRecords.forEach((node: any) => {
            if(rowData.orderID === node.orderID){
                isRecordPresent = false;
            }
        });
        return isRecordPresent;
    }
    removeDeselectedRecordsIfPresent(rowData:any){
        let foundIndex = -1;
        this.deselectedFromSelectAllRecords.forEach((node: any, index) => {
            if(rowData.orderID === node.orderID) {
                foundIndex = index;
            }
        });
        return foundIndex;
    }
    enableDisableBtns() {
        const selectedRows = (this.params && this.params.api && typeof this.params.api.getSelectedRows === 'function') ? this.params.api.getSelectedRows() : [];
        const count = (selectedRows) ? selectedRows.length : 0;
        this.disableActionBtn = count ? false : true;
        let disableEditTradeInstBtn = true;
        this.diableBlockAllocations = true;
        let cancelRecordsCount:number = 0;
        this.disableMarkAsCancelled = true;
        let disableOrderActionBtn = count ? false : true;
        if(count > 0) {
            this.diableBlockAllocations = false;
            let isSecurityTypeVarious = false;
            let securityTypePrev = selectedRows[0].securityType;
            selectedRows.forEach((r: any) => {
                if (r && (!r.isBlockOrder || r.isBlockOrder === false)){
                    this.diableBlockAllocations = true;
                   
                }
                if (r.orderStatus == "CANCEL_REJECTED" || r.orderStatus == "CANCEL_REQUESTED") {
                    cancelRecordsCount++;
                    this.disableMarkAsCancelled = false;
                }
                if (/*(r.securityType === "Equity" || r.securityType === "Option" || r.securityType === "Mutual Fund") &&*/ (r.orderStatus === "APPROVED" ||
                r.orderStatus === "WARNING")) { 
                    disableEditTradeInstBtn = false;
                }
                if (securityTypePrev !== r.securityType) {
                    isSecurityTypeVarious = true;
                }
            });
            if (isSecurityTypeVarious) { disableEditTradeInstBtn = true; }
        }
        disableOrderActionBtn = (count === cancelRecordsCount)?true:(count ? false : true);

        this.diableAllocations = (count > 1 || this.diableBlockAllocations)? true : false;

        if(this.isSelectedAll && count>49){
            disableOrderActionBtn = false;
            disableEditTradeInstBtn = false;
            this.disableMarkAsCancelled = false;
        }
        this.disableOrderActionBtn = disableOrderActionBtn;
        this.disableEditTradeInstBtn = disableEditTradeInstBtn;
    }

    getContextMenuItems(): Array<MenuItemDef> {
        if(!this.disableActionBtn){
            if(this.current == "activeOrders" || this.current == "automatedOrders"){
                return [{
                    name: 'Export',
                    subMenu: [
                        {
                            name: "Order",
                            action: this.exportDetails.bind(this,'orders')
                        },{
                            name: "Block Allocations",
                            action: this.exportDetails.bind(this,'blockAllocations')
                        },{
                            name: "Trades for Thinkpipes",
                            action: this.exportDetails.bind(this,'thinkPipe')
                        }
                    ]
                }]
            } else if(this.current =="resolvedOrders"){
                return [{
                    name: 'Export',
                    subMenu: [            
                        {
                            name: "Order",
                            action: this.exportDetails.bind(this,'orders')
                        },{
                            name: "Block Allocations",
                            action: this.exportDetails.bind(this,'blockAllocations')
                        },{
                            name: "Allocations",
                            action: this.exportDetails.bind(this,'allocations')
                        }
                    ]
                }]  
            }
        }
    }
    
    filterDetailsByRebalIdandPortfolio(event:IEvent) {
        //this.clearAllFiltersAndSelections();
        this.ignoreUserDeselectedRecords = false;
        this.pfs.isArchivedOrders = false;
        this.isSelectedAll= false;
        this.headerCheckBoxState = 'unchecked';
        this.applyFilterOnLanding = event?.data?.state;
        this.applyLandingFilters();

        if (event?.data?.state?.openEditModel) {
            this.pfs.openEditMode = true;
        }
        this.enableDisableBtns();
    }
    filterChanged() {
        // sa 2021-02-24 this is no longer works as booleanfilters section was removed.
        // Originally it is planned to hide Order Status filter when block order filter was set to "On"
        // Needs refactoring if the functionality is still needed
        const columnDefs = this.gls.getColumnDefs(this);
        const filterModel = this.params.api.getFilterModel();
        let _blockOrderFilterActive = false;
        if (filterModel && filterModel.booleanFilters && filterModel.booleanFilters.values
             && filterModel.booleanFilters.values.indexOf('blockOrders') >= 0) {
            for (let i = 0; i < columnDefs.length; i++) {
                if (columnDefs[i].colId === 'orderStatus') {
                    columnDefs[i].filter = false as any;
                    columnDefs[i].filterParams = undefined;
                    _blockOrderFilterActive = true;
                    break;
                }
            }
        }
        if (_blockOrderFilterActive !== this._blockOrderFilterActive) {
            this.params.api.setGridOption('columnDefs', columnDefs);
            this._blockOrderFilterActive = _blockOrderFilterActive;
            this.setCustomFilterLayout();
            this.params.api.getToolPanelInstance('filters').expandFilters(['booleanFilters']);
        }
    }

    exportDetails(action:string){
            let deselectedCounter = 0;
            let selectedCounter = 0;
            let selectedRows = 0;
        
            if (this.isSelectedAll) {
                for (let i = 0; i < this.deselectedFromSelectAllRecords.length; i++) {
                deselectedCounter++;
                }
                selectedRows = this.currentDisplayed -  deselectedCounter;    
            } else {                  
                for (let i = 0; i < this.params.api.getSelectedRows().length; i++) {
                    selectedCounter++;
                }
                selectedRows = selectedCounter;
            }       
        
            if(selectedRows > this._thresholdConfigSettings.OrderExportTreshold){
                this.exportThresholdDialog();
            }else{      
            this.exportService.exportDetails(this,action,this.current,this.isSelectedAll,this.deselectedFromSelectAllRecords,
                this.params.api.getSelectedRows());
            }
     }    
    
    customFilterLayout(params: any) {
        const customToolPanelColumnDefs = [
            {field: "quickfilter" },
            { field: "modifiedDate" },
            { field: "blockOrders" },
            { field: "veoOrderID"},
            { field: "transactionType"},
            { field: "securityType"},
            { field: "ticketType"},
            { field: "rebalanceResultId"},
            { field: "portfolioName"},
            { field: "submittedBy" },
            { field: "masterAccount" },
            { field: "extAccOnly" }
        ];
        const filtersToolPanel = params.api.getToolPanelInstance('filters');

        if (filtersToolPanel) {
            filtersToolPanel.setFilterLayout(customToolPanelColumnDefs);
            filtersToolPanel.expandFilters(['modifiedDate']);
        }
    }
    customFilterLayoutWithQuickFitler(params: any) {
        const customToolPanelColumnDefs =
          (this.ordersSupportDetails && (this.ordersSupportDetails.warningOrders || this.ordersSupportDetails.errorOrders || this.ordersSupportDetails.heldOrders)) ?
          [
            {field: "quickfilter" },
            { field: "blockOrders" },
            { field: "veoOrderID"},
            { field: "transactionType"},
            { field: "securityType"},
            { field: "ticketType"},
            { field: "createdDate" },
            { field: "rebalanceResultId"},
            { field: "portfolioName"},
            { field: "submittedBy" },
            { field: "masterAccount" },
            { field: "extAccOnly" }
        ]:
        [
            {field: "quickfilter" },
            { field: "blockOrders" },
            { field: "veoOrderID"},
            { field: "transactionType"},
            { field: "securityType"},
            { field: "ticketType"},
            { field: "createdDate" },
            { field: "rebalanceResultId"},
            { field: "portfolioName"},
            { field: "submittedBy" },
            { field: "masterAccount" },
            { field: "extAccOnly" }
        ];
        const filtersToolPanel = params.api.getToolPanelInstance('filters');
        if (filtersToolPanel) {
            filtersToolPanel.setFilterLayout(customToolPanelColumnDefs);
            if ((this.ordersSupportDetails && (this.ordersSupportDetails.warningOrders || this.ordersSupportDetails.errorOrders || this.ordersSupportDetails.heldOrders))) {
                filtersToolPanel.expandFilters(['quickfilter']);
            }
        }
    }
    setCustomFilterLayout() {
        if (this.current === 'activeOrders' || this.current === 'automatedOrders') {
            this.customFilterLayoutWithQuickFitler(this.params);
        } else {
            this.customFilterLayout(this.params);
        }
    }

    orderStatusActionBtn(actionType:string){
        this.orderStatusActionProceed(actionType);
    }

     orderStatusActionProceed(actionType:string){
        if(actionType){
            this.actionType = actionType;
           if(this.isSelectedAll && actionType!=='MULTI_EDIT'  && (Number(this.currentDisplayed) > this._thresholdConfigSettings.OrderActionTreshold)){
                this.getOrderStatusCountWithFilter(actionType);
            } else {
                this.getRecordsFromInventory(this.orderStatusActionStart, actionType);
            }
        }
    }

    orderStatusActionStart(t:InventoryComponent,invData:any){
        if(t.actionType === 'MULTI_EDIT'){
            const editTradeData = t.orderStatusAction.getEditTradeInstructionsRecords(invData);
            const isAboveThresholdForMultiEdit = (editTradeData && (editTradeData.selectedRecords.length > t._thresholdConfigSettings.OrderMultiActionTreshold));
            if(isAboveThresholdForMultiEdit){
                t.as.fireEvent(IrbAppEvents.SHOW_CONFIRMATION, {
                    dTitle: 'Attention',
                    dProceedBtnLabel: 'Clear Selections',
                    msg: "You cannot edit trade instructions for more than " + t._thresholdConfigSettings.OrderMultiActionTreshold + " orders at one time. Please select fewer orders to edit.",
                    onProceed: () => {
                        t.refreshGrid()
                    }
                } as IAlertDialogData);
            } else {
                t.workflowDialogData = t.orderStatusAction.actionType(t.actionType, invData);
                t.workflowDialogData.nextAction = () => {
                    t.closeDialog();
                    t.as.fireEvent(IrbClientsEvents.SHOW_EDIT_TRADING_INSTRUCTIONS, {
                        data: editTradeData.selectedRecords,
                        parent: t,
                        actionType: 'MultiEdit',
                        tradeInstructionsinit: true
                    });
                };
                t.openWorkflowDialog();
            }
        } else {
            t.workflowDialogData = t.orderStatusAction.actionType(t.actionType, invData);
            if (t.workflowDialogData.actionType === 'SUBMIT') {
                t.workflowDialogData.nextAction = () => {
                    //t.checkForSubmitWarnings(t.workflowDialogData)
                    const recordsToPost = t.orderStatusAction.getPostData(
                        t.workflowDialogData.itemsToProceed,
                        t.workflowDialogData.actionType);
                    t.updateOrderStatus(recordsToPost, t.workflowDialogData.actionType);
                }
            } else {
                t.workflowDialogData.nextAction = () => {
                    const recordsToPost = t.orderStatusAction.getPostData(
                        t.workflowDialogData.itemsToProceed,
                        t.workflowDialogData.actionType);
                    t.updateOrderStatus(recordsToPost, t.workflowDialogData.actionType);
                }
            }
            t.openWorkflowDialog();
        }
    }
    workflowProceed(){
      if(this.workflowDialogData && this.workflowDialogData.proceedBtnEnable && this.workflowDialogData.actionType){
        this.workflowDialogData.nextAction();     
      }
      }
      updateOrderStatus(itemsToProceed:any, actionType:string){
        this.as.fireEvent(IrbAppEvents.SHOW_WAIT);
        this.pfs.updateOrderStatus(itemsToProceed).subscribe(
          (response: any) => {
            this.closeDialog();
            if(response.responseStatus=="SUCCESS"){
              const isBlockDeskOrdersPresent:boolean = this.orderStatusAction.isBlockDeskOrdersPresent(itemsToProceed, actionType);
              if(isBlockDeskOrdersPresent){
                  this.blockDeskWarningMsg();
              }
              const detailMsg = this.orderStatusAction.orderActionSuccessMsgForBulk(actionType);
              this.as.fireEvent(IrbAppEvents.SHOW_TOAST, { severity: 'success', summary: 'Status', detail: detailMsg });
              if (actionType === 'VALIDATE' || actionType === 'OVERRIDE' || actionType === 'REVERT_TO_APPROVED') {
                  this.refreshGridBtnAction();
              } else {
                  this.refreshGrid();
              }
            } else if (response.responseStatus == "STALEDATAEXCEPTION") {
              this.refreshRequired();
            } else if(response.responseStatus=='EXCEPTION' || response.responseStatus== null) {
                this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
                  severity: 'error',
                  summary: 'Error occurred',
                  detail: 'Error occurred'
              });
            }
            this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
          },
          () => {
            this.closeDialog();
              this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
          }
        );
      }
      checkForSubmitWarnings(wfd:IWorkflowDialogData){
        this.as.fireEvent(IrbAppEvents.SHOW_WAIT);
        const postData = this.orderStatusAction.getSubmitWaringPostData(wfd);
        this.pfs.checkForSubmitWarnings(postData).subscribe(
          (response: any) => {
            if(response.responseStatus=="SUCCESS"){
               const wfdForSubmitWarning:IWorkflowDialogData = this.orderStatusAction.getSubmitWarningMsg(response,this.ordersSupportDetails);
               if(wfdForSubmitWarning && wfdForSubmitWarning.msgList && wfdForSubmitWarning.msgList.length){
                this.workflowDialogData = wfdForSubmitWarning;
                this.workflowDialogData.nextAction = () => {
                    const recordsToPost = this.orderStatusAction.getPostData(
                        wfd.itemsToProceed,
                        wfd.actionType);
                    this.updateOrderStatus(recordsToPost, wfd.actionType);
                }
               }else{
                const recordsToPost = this.orderStatusAction.getPostData(
                    wfd.itemsToProceed,
                    wfd.actionType);
                this.updateOrderStatus(recordsToPost, wfd.actionType);
               }
            } else {
                this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
            }
          },
          () => {
            this.closeDialog();
            this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
          }
        );
      }
    
    openWorkflowDialog(): void {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
            dialogConfig.panelClass = "irb-dialog";
            dialogConfig.autoFocus = false;
        this.dialog.open(this.workflowDialogTemplate, dialogConfig);
      }
      closeDialog(): void{
        this.dialog.closeAll();
      }

    getRecordsFromInventory(callBack: any, actionType: string) {
        const records = this.params.api.getSelectedRows();
        const loadedInGrid = Number(this._recordsLoadedInGrid);
        const isPartialBelowCapSelection = (records.length > 0 && records.length <= 50) || (records.length <= loadedInGrid);

        if (!this.isSelectedAll && isPartialBelowCapSelection) {
            return callBack(this, records);
        } else if (this.isSelectedAll || records.length > 50) {
            this.getOrdersByFilter(callBack, actionType);
        }
    }

    getOrdersByFilter(callBack: any, actionType: string) {
        let deselectedIds: Array<any> = [];
        this.deselectedFromSelectAllRecords.forEach((node: any) => {
            deselectedIds.push(node.orderID);
        });
        const postData = {
            current: this.current,
            isSelectAll: this.isSelectedAll,
            isExport: false,
            isMultiEdit: false,
            deselectedIds: deselectedIds
        };


        if (actionType === 'MULTI_EDIT') {
            if (this.currentDisplayed > this._thresholdConfigSettings.OrderMultiActionTreshold) {
                this.as.fireEvent(IrbAppEvents.SHOW_CONFIRMATION, {
                    dTitle: 'Attention',
                    dProceedBtnLabel: 'Clear Selections',
                    msg: "You cannot edit trade instructions for more than " + this._thresholdConfigSettings.OrderMultiActionTreshold + " orders at one time. Please select fewer orders to edit.",
                    onProceed: () => {
                        this.refreshGrid()
                    }
                } as IAlertDialogData);
                return;
            }
        }

        console.log("this.pfs.getOrdersByFilter")
        this.pfs.getOrdersByFilter(postData).subscribe((res: any) => {
            let records = res.ordersList;
            console.log("this.pfs.getOrdersByFilter ----- callBack")
            if (callBack) {
                callBack(this, records);
            }
        });
    }

    validateThinkPipeDialog(request:IExportRequest,validateThinkPipeFormat:IValidateThinkPipeExport): void {
        this.exportRequest = request;
        this.validateThinkPipeFormat = validateThinkPipeFormat;
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.panelClass = "irb-dialog";
        dialogConfig.autoFocus = false;
        this.dialog.open(this.validateDialogTemplate, dialogConfig);
    }
    getOrderTresholdLimits(){
        this.pfs.getOrderTresholdLimits().subscribe((res: any) => {

            if(res.responseStatus==='SUCCESS'){
                this._thresholdConfigSettings.OrderActionTreshold = res.responseData.OrderActionTreshold;
                this._thresholdConfigSettings.OrderExportTreshold = res.responseData.OrderExportTreshold;
                this._thresholdConfigSettings.OrderMultiActionTreshold = res.responseData.OrderMultiActionTreshold;
                this._thresholdConfigSettings.isAutomatedOrderActionEnable = res.responseData.isAutomatedOrderActionEnable;
                this.blockDeskContact = res.responseData.blockDeskContact;
            }
        });
    }

    exportThresholdDialog(): void {
        this.as.fireEvent(IrbAppEvents.SHOW_CONFIRMATION, {
            dTitle: 'Attention',
            dProceedBtnLabel: 'Clear Selections',
            msg: 'You cannot export more than ' + this._thresholdConfigSettings.OrderExportTreshold + ' orders at one time. Please select fewer orders to export.',
            onProceed: () => {this.refreshGrid()}
        } as IAlertDialogData);
    }

      exportBlockAllocationDialog(): void {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.panelClass = "irb-dialog";
        dialogConfig.autoFocus = false;
        this.dialog.open(this.exportBlockAllocation, dialogConfig);
      }

      deselectRows(){     
        this.params.api.deselectAll();
      }

      continueExportThinkPipe(){
          this.dialog.closeAll();
       this.exportService.exportThinkPipeFormat(this.exportRequest);
      }

// Note : As per Michael King need slid out edit  not inline edit

    //   onRowChange(rowIndex: number, dataToUpdate: IOrders){ 
    //     this.overlayType = 'loading';
    //     this.params.api.showLoadingOverlay();
    //     this.pfs.saveInlineBlotter(dataToUpdate).subscribe((response: any) => {
    //     this.params.api.hideOverlay();
    //     this.params.api.hideOverlay();
    //     if (response.responseStatus === "SUCCESS") {
    //        this.as.fireEvent(IrbAppEvents.SHOW_TOAST, { severity: 'success', summary: 'Success', detail: 'Your change has been saved' });
    //     }else {                
    //         this.as.fireEvent(IrbAppEvents.SHOW_TOAST, { severity: 'error', summary: 'Update failed.', detail: 'Update failed"' });
    //         this.params.api.hideOverlay();
    //       }
    //     }, (err: HttpErrorResponse) => {
    //         false && console.error(rowIndex,"error :",err);
    //         this.params.api.hideOverlay();
    //     });
    //   }
      
      blockOrdersDialog(response:any,rowData:IOrders): void {
        this.blockOrder = rowData;
        if (this.blockOrder.expirationDate) {
            if (typeof this.blockOrder.expirationDate === "number") {
                this.blockOrder.expirationDate = this.gls.getExpirationTime(Number(this.blockOrder.expirationDate));
            }
        }
        this.viewBlockOrder=response;
        this.openGrid = true;
       
        this.blockOrderGridOptions = {
            columnDefs: this.gls.getColumnDefsBlockOrder(this),
            skipHeaderOnAutoSize: true,
            floatingFilter: false,
             
          };
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.panelClass = "irb-dialog";
        dialogConfig.autoFocus = false;
        
        this.dialog.open(this.blockOrdersTemplate, dialogConfig);
      }
      getOrderStatusCountWithFilter(actionType:string){
         let deselectedIds:Array<any> = [];
         let deselectedIdList:Array<any> = [];
         this.deselectedFromSelectAllRecords.forEach((node: any) => {
            deselectedIds.push(node.orderID);
            deselectedIdList.push(node.orderID.toString());
        });
        const postData = {
            current:this.current,
            isSelectAll:this.isSelectedAll,
            isExport:false,
            isMultiEdit: false,
            deselectedIds: deselectedIds
        };
        this.pfs.getOrderStatusCountWithFilter(postData).subscribe((res: any) => {
            const blockDeskRecords:boolean = (res.AOM_PRINTER);
            this.workflowDialogData = this.orderStatusAction.actionTypeAboveTreshold(actionType,res);
            this.workflowDialogData.nextAction = () =>{
                this.updateAsynchOrderStatus({
					isFilterApplied: this._filterCriteria?true:false,
                    orderAction: this.workflowDialogData.actionType,
                    resolvedOnly: (this.current === 'resolvedOrders'),
                    selectAllFlag: this.isSelectedAll,
                    deselectedIdList: deselectedIdList,
                    selectedIdList: [],
                    isSelectedOrders:false,
                    currentTab: this.current
				},blockDeskRecords)
            };
            this.openWorkflowDialog();
        });
    }
    updateAsynchOrderStatus(postData:any,blockDeskRecords:boolean){
        const actionType = postData.orderAction;
        this.pfs.updateAsynchOrderStatus(postData).subscribe((response: any) => {
            this.closeDialog();
            if(response.responseStatus=="SUCCESS"){
                this.openIrbProgressBarOrdStatUpdIdwDialog();
                this.ordStatUpdIdprogressBarValue = 0;
                this.getOrderStatusUpdate(response.responseUtilityMap.ordStatUpdId,blockDeskRecords, actionType);
              } else if (response.responseStatus == "STALEDATAEXCEPTION") {
                this.refreshRequired();
              } else if(response.responseStatus=='EXCEPTION') {
                  this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
                    severity: 'error',
                    summary: 'Error occurred',
                    detail: 'Error occurred'
                });
              }
        },
        () => {
          this.closeDialog();
        }
      );
    }
    getOrderStatusUpdate(ordStatUpdId:number, blockDeskRecords:boolean, actionType: string){
        this.pfs.getOrderStatusUpdate(ordStatUpdId).subscribe((response: any) => {
                        
            if(response.reqStatus == "FAILED"){
                this.closeDialog();
                this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
                    severity: 'error',
                    summary: 'Failed',
                    detail: response.failMsg
                });
              } else if (response.reqStatus == "STARTED" || response.reqStatus == "IN_PROGRESS" || response.reqStatus == "STOPPING") {
                this.updateProgressBarStatus(response,blockDeskRecords, actionType);
              } else if(response.reqStatus == "COMPLETED") {
                  
                if(actionType === 'SUBMIT' && blockDeskRecords){
                    this.blockDeskWarningMsg();
                }
                this.closeDialog();
                if (actionType === 'VALIDATE' || actionType === 'OVERRIDE' || actionType === 'REVERT_TO_APPROVED') {
                    this.refreshGridBtnAction();
                } else {
                    this.refreshGrid();
                }
              } else if(response.reqStatus == "STOPPED"){
                this.closeDialog();
                this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
                    closable:true,
                    sticky:true,
                    // life:10000,
                    severity: 'error',
                    summary: 'Stopped',
                    detail: 'Block job execution was stopped by another user in the environment.'
                });
                this.refreshGridBtnAction();
              }
        },
        () => {
          this.closeDialog();
        }
      );
    }
    openIrbProgressBarOrdStatUpdIdwDialog(): void {
        this.ordStatUpdIdprogressBarValue = 0;
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.panelClass = "irb-dialog";
        dialogConfig.autoFocus = false;
        dialogConfig.minHeight = "100px";
        dialogConfig.height = "auto";
        dialogConfig.width = "650px";
        this.dialog.open(this.irbProgressBarOrdStatUpdId, dialogConfig);
    }

    updateProgressBarStatus(response: any, blockDeskRecords: boolean, actionType: string) {
        const cnt = response.failedRecCount + response.successRecCount, rcnt = response.recievedCount;
        if (cnt > 0) {
            this.ordStatUpdIdprogressBarValue = Math.floor((cnt * 100) / rcnt);
        }
        setTimeout(() => {
            this.getOrderStatusUpdate(response.statusUpdateId, blockDeskRecords, actionType);
        }, 5000);
    }

    rowClickedAction(cellParams: any) {
        if (this.showThresholdAlert) {
            const selectedRows = (this.params && this.params.api && typeof this.params.api.getSelectedRows === 'function') ? this.params.api.getSelectedRows() : [];
            if (selectedRows.length) {
                if (selectedRows.length && cellParams.column.colId === 'selectAll'
                    && ((selectedRows.length > this._thresholdConfigSettings.OrderActionTreshold)
                        || (this.isSelectedAll && Number(this.currentDisplayed) > this._thresholdConfigSettings.OrderActionTreshold)
                    )) {
                    this.as.fireEvent(IrbAppEvents.SHOW_CONFIRMATION, {
                        dTitle: 'Attention',
                        dProceedBtnLabel: 'Clear Selections',
                        msg: "You've selected a greater number of items than can be processed. Please finish taking action on your previous selections before selecting more.",
                        onProceed: () => {
                            this.refreshGrid()
                        },
                        onCancel: () => {
                            this.showThresholdAlert = false;
                            setTimeout(() => {
                                this.showThresholdAlert = true
                            }, 10); // to avoid loop
                            cellParams.event.target.click(); // to trigger all proper event in custom-header
                        }
                    } as IAlertDialogData);
                }
            }
        }
    }

    refreshRequired() {
        this.as.fireEvent(IrbAppEvents.SHOW_CONFIRMATION, {
            dTitle: 'Refresh Required',
            dProceedBtnLabel: 'Refresh',
            msg: "You are attempting to edit an order that was just modified by someone else. To see the updated order, you need to refresh the page.",
            onProceed: () => {
                this.refreshGrid()
            }
        } as IAlertDialogData);
    }

    close() {
         this.dialog.closeAll();
      }
    blockDeskWarningMsg(){
        this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
            severity: 'warn',
            closable:true,
            sticky:true,
            summary: 'Block desk',
            detail: "Your order has been sent to the block desk. Please refresh your order blotter to confirm that an order ID was received. If accepted, you should receive a call from the block desk at the number you provided. If you do not receive a call back within the next 2 minutes, please call the block desk at " + this.blockDeskContact + "."
        });
    }
    getIsOptionTradeEnabled(){
        this.pfs.getIsOptionTradeEnabled().subscribe((response: any) => {
           if(response.responseStatus=="SUCCESS"){
            this.isOptionTradeEnabled = response.responseData;
           }
        }
      );
    }

    isDisabled(rowData: any) {
        return rowData.securityType === "Option" && !this.isOptionTradeEnabled;
    }
    
    importOrders(){
        this.as.fireEvent(IrbOrdersEvents.SHOW_IMPORT_ORDERS, {currentTab: this.current});
     }

     getPermissions() {
        const self = this;
        self.pfs.getPermissions().subscribe((response: any) => {
          if (response?.responseStatus == "SUCCESS") {
            // This List for view/edit not held overlay.
            this.algorithmPermissionsList = response.responseData;
          }

        });
      }
      updateMultipleOrders(itemsToProceed:any){
        this.pfs.updateMultipleOrders(itemsToProceed).subscribe(
          (response: any) => {
            if(response.responseStatus=="SUCCESS"){

             this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
                            key: 'irb-spinner-toast',
                            severity: 'warn',
                            summary: "Updating Orders in progress",
                            detail: "Your request is being processed.",
                            sticky: true,
                            closable: true
                          });
                this.updateMultipleOrdersStatus(response.responseUtilityMap.statusId, itemsToProceed);

            } else if (response.responseStatus == "STALEDATAEXCEPTION") {
              this.refreshRequired();
            } else if(response.responseStatus=='EXCEPTION') {
                this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
                  severity: 'error',
                  summary: 'Error occurred',
                  detail: 'Error occurred'
              });
                if (!this.isUiTest) {
                    throw new Error('Edit trade instruction. updateMultipleOrders failed.');
                }
            }
          },
          (err: HttpErrorResponse) => {
            this.closeDialog();
            // console.error(err);
            let m = 'Edit trade instruction. updateMultipleOrders failed. ';
            if (err.message) {
                m += err.message;
            }
            if (!this.isUiTest) {
                throw new Error(m);
            }
          }
        );
      }

     updateMultipleOrdersStatus(statusId: string, itemsToProceed:any) {
        this.updateMultipleOrdersSub = interval(3000).subscribe(() => {
            this.pfs.updateMultipleOrdersStatus(statusId).subscribe((response: any) => {
              if(response.responseData.reqStatus.toUpperCase() == "COMPLETED") {
                this.as.fireEvent(IrbAppEvents.HIDE_TOAST);
                this.as.fireEvent(IrbAppEvents.SHOW_TOAST, { severity: 'success', summary: 'Success', detail: 'Your change has been saved' });
                
                if(itemsToProceed && itemsToProceed.length){
                    this.updateContactNumbers({
                      contactNo:itemsToProceed[0].userContactNo
                    });
                }

                this.updateMultipleOrdersSub.unsubscribe();
                this.refreshGridBtnAction();
              } else if(response.responseData.reqStatus.toUpperCase() == "FAILED") {
                this.as.fireEvent(IrbAppEvents.HIDE_TOAST);
                  this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
                    severity: 'error',
                    summary: 'Edit trade instruction. updateMultipleOrders failed.',
                    detail: 'An error occurred processing your request.'
                  });
                this.updateMultipleOrdersSub.unsubscribe();
              } else if(response.responseData.reqStatus.toUpperCase() == "IN_PROGRESS") {
                }
              });
        });

     }


      updateContactNumbers(itemsToProceed:IUpdateContactNumbers){
          if(itemsToProceed && itemsToProceed.contactNo){
        this.pfs.updateContactNumbers(itemsToProceed).subscribe(
          (response: any) => {
            if(response.responseStatus=="SUCCESS"){
                this.envLastUsedContactNo = itemsToProceed.contactNo;
            } else if(response.responseStatus=='EXCEPTION') {
                this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
                  severity: 'error',
                  summary: 'Error occurred',
                  detail: 'Error occurred'
              });
                if (!this.isUiTest) {
                    throw new Error('Order blotter. updateContactNumbers failed.');
                }
            }
          },
          (err: HttpErrorResponse) => {
              //console.error(err);
              let m = 'Order blotter. updateContactNumbers failed. ';
              if (err.message) {
                  m += err.message;
              }
              if (!this.isUiTest) {
                  throw new Error(m);
              }
          }
        );
          }
      }

    getCurrentDate() {
        const now = new Date();
        let r = now.toLocaleString('en-US',
          {timeZone: 'America/New_York', year: 'numeric', month: 'numeric', day: 'numeric'}); // 1/2/2001
        const mdy = r.split('/');
        if (!mdy || mdy.length !==3) { return null; }
        let m = mdy[0]; if (m.length === 1) { m = '0' + m; }
        let d = mdy[1]; if (d.length === 1) { d = '0' + d; }
        let y = mdy[2];
        return y + '-' + m + '-' + d;
    }

    orderHistoryDialog(params:any,inventoryComponent:InventoryComponent){

        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.panelClass = "irb-dialog";
        dialogConfig.autoFocus = false;
        dialogConfig.minHeight = "100px";
        dialogConfig.height = "auto";
        dialogConfig.width = "650px";
        this.currentOrderData = params.data;
        this.inventoryComponentRef = inventoryComponent;
        this.orderHistoryDialogRef =  this.dialog.open(this.orderHistoryTemplate, dialogConfig);
    }
    closeHistoryDialog() {
        this.orderHistoryDialogRef && this.orderHistoryDialogRef.close();
    }
    getContactNumbers(){
      this.pfs.getContactNumbers().subscribe(
        (response: any) => {
         this.envLastUsedContactNo = response.contactNo;
        });
    }
    showPortfolioResultDetail(rebalanceID: any, portfolioId: any) {
        const self = this;
        if (self.routeQueryParams$) { self.routeQueryParams$.unsubscribe(); }
        self.router.navigate([], {
            relativeTo: self.route,
            queryParams: {rebalanceId: rebalanceID, portfolio: portfolioId},
            replaceUrl: true
        });
        const timeout = this.isUiTest ? 0 : 250;
        setTimeout(() => {
            self.as.fireEvent(IrbRebalanceEvents.SHOW_PORTFOLIO_RESULT_DETAIL, {
                fullscreen: true,
                request: { method: "getDetails", rebalId:rebalanceID, portfolioId: portfolioId, secListLoadReqd: true },
            });
        }, timeout)
    }

    onCellValueChanged(params: any) {
        if (params.oldValue !== params.newValue) {
           let orderToUpdate = {} as IUpdateAmtType;
            orderToUpdate.orderID = params.data?.orderID;
            orderToUpdate.versionId = params.data?.versionId;
            orderToUpdate.defaultOrderPriceType = params.data?.defaultOrderPriceType;
            orderToUpdate.amountType = params.newValue;
            if (orderToUpdate.amountType === 'Shares') {
                orderToUpdate.feesOption = 'INCLUDE';
            }

            this.overlayType = 'loading';
            this.params.api.showLoadingOverlay();
            this.pfs.updateOrder(orderToUpdate).subscribe((data) => {
             if (data.responseStatus === 'SUCCESS') {
                    this.params.api.hideOverlay();

                    this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
                        severity: 'success',
                        summary: 'Success',
                        detail: 'Your change has been saved'
                    });

                    params.data.edited = false;
                    params.data.versionId = data.responseData?.versionId;
                    params.data.feesOption = data.responseData?.feesOption;

                    if(this.params && this.params.api && this.params.api.getDisplayedRowAtIndex) {
                        const rowIndex = this.params.rowIndex || this.params.node.rowIndex;
                        const n = this.params.api.getDisplayedRowAtIndex(rowIndex);
                        this.params.api?.redrawRows({rowNodes: [n]});
                    }
                } else {
                    this.overlayType = 'error';
                    this.params.api.showLoadingOverlay();

                    if (!this.isUiTest) {
                        throw new Error('Order blotter. updateOrder failed. orderToUpdate.orderID=' + orderToUpdate.orderID);
                    }
                }        
            }, () => this.params.api.hideOverlay());
          }
      }

    private setFilterChipsDisplayNames() {
        this.filterDisplayNamesData= [];
        this.filterDisplayNamesData.push({key: 'accountNumber', mapData: {displayName: 'Account', customData:{}}});
        this.filterDisplayNamesData.push({key: 'accountName', mapData: {displayName: 'Account Name', customData:{}}});
        this.filterDisplayNamesData.push({key: 'securitySymbol', mapData: {displayName: 'Symbol', customData:{}}});
        this.filterDisplayNamesData.push({key: 'orderStatus', mapData: {displayName: 'Order Status', customData:{}}});
        this.filterDisplayNamesData.push({key: 'veoOrderID', mapData: {displayName: 'Order ID', customData:{}}});
        this.filterDisplayNamesData.push({key: 'transactionType', mapData: {displayName: 'Trans Type', customData:{}}});
        this.filterDisplayNamesData.push({key: 'securityType', mapData: {displayName: 'Sec Type', customData:{}}});
        this.filterDisplayNamesData.push({key: 'ticketType', mapData: {displayName: 'Tkt Type', customData: { valueMaps: {'A':'Automated', 'E': 'Electronic', 'M':'Manual'} }}});
        this.filterDisplayNamesData.push({key: 'createdDate', mapData: {displayName: 'Approval Date', customData:{}}});
        this.filterDisplayNamesData.push({key: 'rebalanceResultId', mapData: {displayName: 'Rebal ID', customData:{}}});
        this.filterDisplayNamesData.push({key: 'portfolioName', mapData: {displayName: 'Portfolio', customData:{}}});
        this.filterDisplayNamesData.push({key: 'submittedBy', mapData: {displayName: 'Submitted By', customData:{}}});
        this.filterDisplayNamesData.push({key: 'masterAccount', mapData: {displayName: 'Master Account', customData:{}}});
        this.filterDisplayNamesData.push({key: 'extAccOnly', mapData: {displayName: 'External Accounts', customData:{}}});
        this.filterDisplayNamesData.push({key: 'blockOrders', mapData: {displayName: 'Block Orders', customData:{}}});
        this.filterDisplayNamesData.push({key: 'modifiedDate', mapData: {displayName: 'Closed Date', customData:{}}});
    }

    onRemoveFilterItem(filterChip: any) {
        let filterField = filterChip[0];
        this.params.api.getColumnFilterInstance(filterField).then((f:any) => {
            f.setModel(null);
            this.params.api.onFilterChanged();
        });
    }

    applySelectedGridFilter(filterModel: any) {
        if (filterModel == null) {
            this.clearAllFiltersAndSelections();
            this.gridPresetFiltersComp.setToNoFilter();
        } else {

            if (this.current === 'resolvedOrders' && filterModel.modifiedDate) {
                this.params.api.setColumnFilterModel('modifiedDate', filterModel.modifiedDate);
                this.params.api.setGridOption('serverSideDatasource', this.setDatasource())
                return;
            }


            const currentGridFilterModel = this.params.api.getFilterModel();
            if (currentGridFilterModel && currentGridFilterModel.quickfilter) {
                const quickfilter: any = currentGridFilterModel.quickfilter;
                filterModel.quickfilter = quickfilter;
            }
            this.appliedFromPresetFilter = true;
            this.params.api.setFilterModel(filterModel);
        }
    }

    getCurrentFilterModel() {
        const currentGridFilterModel = JSON.parse(JSON.stringify(this.params.api.getFilterModel()));
        delete currentGridFilterModel.quickfilter;
        return currentGridFilterModel;
    }

    openGlobalSettings() {
        this.as.fireEvent(IrbSettingsEvents.SHOW, {defaultTabIndex: 6});
    }

    openSACWithContext(sanc: string) {
        // If no row data, open SAC without context
        if (!this.row) {
            window.open(`${this.redirectURL}/?sanc=${sanc}`, '_blank');
            return;
        }

        const baseURL = this.util.getSacContextGatewayBaseURL();
        const firmId = this.userDetails?.firmId;

        this.cxs.init(baseURL, firmId);

        const currentContext: IContext = {
            contextId: this.row.accountNumber,
            contextType: ContextType.Account,
            name: this.row.accountName || this.row.accountNumber
        };

        this.cxs.save(currentContext)
            .then((ubid: string) => {
                const url = ubid
                    ? `${this.redirectURL}/?sanc=${sanc}&ubid=${ubid}`
                    : `${this.redirectURL}/?sanc=${sanc}`;
                window.open(url, '_blank');
            })
            .catch(() => {
                // Fallback: open SAC without UBID on error
                window.open(`${this.redirectURL}/?sanc=${sanc}`, '_blank');
            });
    }

    getTemplate(params: any) {
        this.row = params.data;
        return this.accountNumberOverlay;
    }

    closeMenu() {
        this.ctas.remove();
    }


    showQuickOrderEntry() {
        this.as.fireEvent(IrbOrdersEvents.SHOW_QUICK_ORDER_ENTRY, {});
    }
}
